export {default as replaceAliases} from './replace-aliases'
